import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_inventory_transformations_by_status_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[] }): 
  Promise<{ result: { inventory_transformation_by_status?: number, InventoryTransformationStatus?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_by_status_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { inventory_transformation_by_status?: number, InventoryTransformationStatus?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_by_status_widget/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], $keys: any[] }): 
  Promise<{ result: { inventory_transformation_by_status?: number, InventoryTransformationStatus?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_by_status_widget/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[]    }) {
      return false;
    }
}
